import { Grid, Typography } from '@mui/material';
import { SahinSwitch } from 'common/components/SahinSwitch/SahinSwitch';
import { Control, Controller } from 'react-hook-form';

interface SettingSwitchFieldProps {
  control: Control<any>;
  label: string;
  name: string;
  helperText?: string;
}

export const SettingSwitchField = ({
  control,
  label,
  name,
  helperText,
}: SettingSwitchFieldProps) => {
  return (
    <>
      <Grid xs={10} direction="column" item container>
        <Typography>{label}</Typography>
        {helperText && (
          <Typography color="text.secondary">{helperText}</Typography>
        )}
      </Grid>
      <Grid xs={2} justifyContent="flex-end" item container>
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <SahinSwitch
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              inputRef={ref}
              size={1}
            />
          )}
        />
      </Grid>
    </>
  );
};
